import React from 'react'
import { App as AntdApp, ConfigProvider } from 'antd'
import { BrowserRouter as Router } from 'react-router-dom'
import { Layout } from 'antd'
import RoutesComponent from './router/RoutesComponent'
import { UserProvider } from './utils/contexts/UserContext'
import { BrowserRouter } from 'react-router-dom'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')


// 解构出布局组件
const { Content } = Layout

const App: React.FC = () => {
  return (
    <BrowserRouter basename="/">
      <ConfigProvider locale={zhCN}>
        <AntdApp>   
          <UserProvider>
            <Layout>
              <RoutesComponent />
            </Layout>
          </UserProvider>
        </AntdApp>
      </ConfigProvider>
    </BrowserRouter>
  )
}

export default App
